// 配置路由相关信息
import VueRouter from 'vue-router'
import Vue from 'vue'
import storage from '../utils/storage'

const Login = () => import('../views/Login.vue')
const Home = () => import('../views/Home.vue')
const OrderList = () => import('../views/OrderList.vue')
const OrderMineList = () => import('../views/OrderMineList.vue')
const OrderComplain = () => import('../views/OrderComplain.vue')
const ServiceMange = () => import('../views/ServiceMange.vue')
const OrderDataManage = () => import('../views/dataMange/OrderDataManage.vue')
const OrderDataDetail = () => import('../views/dataMange/OrderDataDetail.vue')
const OrderDataList = () => import('../views/dataMange/OrderDataList.vue')
const SubzoneDataList = () => import('../views/subzoneDataMange/index.vue')
const Mine = () => import('../views/Mine.vue')
const Register = () => import('../views/register.vue')
const Qrcode = () => import('../views/Qrcode.vue')
const SearchOrder = () => import('../views/SearchOrder.vue')
const SearchTel = () => import('../views/SearchTel.vue')

// 安装插件
Vue.use(VueRouter)


// 创建VueRouter对象
const routes = [
    {
        path: '/',
        name: 'home',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/orderMineList',
        name: 'orderMineList',
        component: OrderMineList,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/serviceMange',
        name: 'serviceMange',
        component: ServiceMange,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/orderDataManage',
        name: 'orderDataManage',
        component: OrderDataManage,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/orderDataDetail/:id',
        name: 'orderDataDetail',
        component: OrderDataDetail,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/orderDataList/:id',
        name: 'orderDataList',
        component: OrderDataList,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/subzoneDataList',
        name: 'subzoneDataList',
        component: SubzoneDataList,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/orderList',
        name: 'orderList',
        component: OrderList,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/orderComplain',
        name: 'orderComplain',
        component: OrderComplain,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
            // showNav: true,
        }
    },
    {
        path: '/mine',
        name: 'mine',
        component: Mine,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/qrcode/:type',
        name: 'qrcode',
        component: Qrcode,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
            showNav: true,
        }
    },
    {
        path: '/login/:qywx_userid',
        name: 'login',
        component: Login,
        meta: {
            showNav: true,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            showNav: true,
        }
    },
    {
        path: '/searchOrder',
        name: 'searchOrder',
        component: SearchOrder,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/searchTel',
        name: 'searchTel',
        component: SearchTel,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    // 接单
    {
        path: '/tekeOrder',
        name: 'takeOrderIndex',
        redirect: '/tekeOrder/tOrderIndex/:id',
        component: () => import('../views/takeOrder/TakeOrderIndex.vue'),
        children: [
            {
                path: 'tOrderIndex/:id',
                name: 'tOrderIndex',
                component: () => import('../views/takeOrder/index.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'tOrderList/:phoneend/:type',
                name: 'tOrderList',
                component: () => import('../views/takeOrder/orderList.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
        ],
    },
    // 取餐
    {
        path: '/tekeMeal',
        name: 'takeMealIndex',
        redirect: '/tekeMeal/tMealIndex/:id/:isOrder',
        component: () => import('../views/takeMeal/TakeMealIndex.vue'),
        children: [
            {
                path: 'tMealIndex/:id/:isOrder',
                name: 'tMealIndex',
                component: () => import('../views/takeMeal/index.vue'),
                meta: {
                    // showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'tMealRefuse/:id',
                name: 'tMealRefuse',
                component: () => import('../views/takeMeal/refuse.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            }
        ],
    },
    // 送餐
    {
        path: '/sendMeal',
        name: 'sendMealIndex',
        redirect: '/sendMeal/sMealIndex/:id',
        component: () => import('../views/sendMeal/SendMealIndex.vue'),
        children: [
            {
                path: 'sMealIndex/:id',
                name: 'sMealIndex',
                component: () => import('../views/sendMeal/index.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
        ],
    },
    // 配送
    {
        path: '/dispatch',
        name: 'dispatchIndex',
        redirect: '/dispatch/dIndex/:id',
        component: () => import('../views/dispatch/DispatchIndex.vue'),
        children: [
            {
                path: 'dIndex/:id',
                name: 'dIndex',
                component: () => import('../views/dispatch/index.vue'),
                meta: {
                    // showNav: true,
                    requireAuth: true,
                }
            },
        ],
    },
    // 跑腿业务
    {
        path: '/parkFlash',
        name: 'parkFlashIndex',
        redirect: '/parkFlash/pIndex/:id',
        component: () => import('../views/parkFlash/ParkFlashIndex.vue'),
        children: [
            {
                path: 'pIndex/:id',
                name: 'pIndex',
                component: () => import('../views/parkFlash/index.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'pList',
                name: 'pList',
                component: () => import('../views/parkFlash/list.vue'),
                meta: {
                    // showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'pDetail/:id',
                name: 'pDetail',
                component: () => import('../views/parkFlash/detail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'pOrderMineListManage',
                name: 'pOrderMineListManage',
                component: () => import('../views/parkFlash/orderMineListManag.vue'),
                meta: {
                    // showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'pDetailManag/:id',
                name: 'pDetailManag',
                component: () => import('../views/parkFlash/detailManag.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'pOrderList',
                name: 'pOrderList',
                component: () => import('../views/parkFlash/orderMineList.vue'),
                meta: {
                    requireAuth: true,
                }
            },
            {
                path: 'pMineDetail/:id',
                name: 'pMineDetail',
                component: () => import('../views/parkFlash/mineDetail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
        ],
    },
    {
        path: '/userIndex',
        name: 'userIndex',
        component: () => import('../views/userManage/UserIndex.vue'),
        redirect: '/userIndex/userEdit',
        children: [
            {
                path: 'userEdit',
                name: 'userEdit',
                component: () => import('../views/userManage/edit.vue'),
                meta: {
                    showNav: false 
                }
            }
        ],
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/complainIndex',
        name: 'ComplainIndex',
        redirect: '/complainIndex/complainDetail/:id',
        component: () => import('../views/complain/ComplainIndex.vue'),
        children: [
            {
                path: 'complainDetail/:id',
                name: 'complainDetail',
                component: () => import('../views/complain/detail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
        ],
    },
    {
        path: '/orderIndex',
        name: 'OrderIndex',
        redirect: '/orderIndex/orderDetail/:id',
        component: () => import('../views/order/OrderIndex.vue'),
        children: [
            {
                path: 'orderDetail/:id',
                name: 'orderDetail',
                component: () => import('../views/order/detail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
            {
                path: 'orderMineDetail/:id/:address_detail/:order_status',
                name: 'orderMineDetail',
                component: () => import('../views/order/mineDetail.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            },
        ],
    },
]

// 
const router = new VueRouter({
    // mode: 'hash',
    routes,
    scrollBehavior() {
        // to, from, savedPosition
        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
    //根据字段判断是否路由过滤
    let OPENID = storage.get('OPENID');
    if (to.matched.some(record => record.meta.requireAuth)) {

        if (OPENID != '' && OPENID != null) {
            next()
        } else {
            //防止无限循环
            if (to.name === 'login') {
                next();
                return
            }
            next({
                path: "/login/1",
            });
        }
    } else {
        if (OPENID != '' && OPENID != null) {
            next({
                path: "/home",
            });
        } else {
            next()//若点击的是不需要验证的页面,则进行正常的路由跳转
        }

    }
});



// 将router对象传入到Vue实例中
export default router